import type { ConditionalLogic, ConditionType } from "../types/form.types";

export type FormLogicContext = Record<string, string>;

export const CONTEXT_TRIGGER_PREFIX = "ctx:";

export const PROVIDER_TYPE_CONTEXT_KEY = "provider.type";

export const PROVIDER_TYPE_TRIGGER_ID = `${CONTEXT_TRIGGER_PREFIX}${PROVIDER_TYPE_CONTEXT_KEY}`;

export const NO_PROVIDER_TYPE = "none";

export const PROVIDER_TYPE_OPTIONS = [
  { value: "reactive_hire", label: "Reactive hire" },
  { value: "per_job", label: "Per-job rate" },
  { value: "hourly", label: "Hourly rate" },
  { value: "w2", label: "W2 technician" },
  { value: NO_PROVIDER_TYPE, label: "No provider" },
];

export const CONTEXT_TRIGGER_CONDITIONS: { value: ConditionType; label: string }[] = [
  { value: "is", label: "Is" },
  { value: "is_not", label: "Is not" },
  { value: "is_any_of", label: "Is any of" },
  { value: "is_not_any_of", label: "Is not any of" },
];

export const CONTEXT_TRIGGERS = [
  {
    id: PROVIDER_TYPE_TRIGGER_ID,
    name: "Provider type",
    label: "Context · Provider type",
    options: PROVIDER_TYPE_OPTIONS,
  },
];

export const isContextTrigger = (triggerId: string | undefined): boolean =>
  !!triggerId && triggerId.startsWith(CONTEXT_TRIGGER_PREFIX);

export const getContextTrigger = (triggerId: string | undefined) =>
  CONTEXT_TRIGGERS.find((trigger) => trigger.id === triggerId);

export function describeContextCondition(rule: ConditionalLogic): string | null {
  const trigger = getContextTrigger(rule.triggerQuestionId);
  if (!trigger) return null;
  const condition = CONTEXT_TRIGGER_CONDITIONS.find((c) => c.value === rule.condition);
  const values = (rule.triggerValues || []).map(
    (value) => trigger.options.find((o) => o.value === value)?.label ?? value,
  );
  return [trigger.name, condition?.label.toLowerCase() ?? rule.condition, values.join(", ")]
    .filter(Boolean)
    .join(" ");
}

export const buildProviderTypeContext = (providerType: string): FormLogicContext => ({
  [PROVIDER_TYPE_CONTEXT_KEY]: providerType,
});
